<div class="news-list"  *ngIf="!loading" >
  <div *ngFor="let newsItem of news | paginate:  { itemsPerPage: newsCountOnPage, currentPage: page, totalItems: total }" class="product-item">

    <news-item [news]="newsItem"></news-item>

  </div>

</div>
<pagination-controls  *ngIf="news &&  total > newsCountOnPage" class="pagination" previousLabel=""
                      nextLabel=""
                      (pageChange)="change($event);upPage()"
>

</pagination-controls>
<div class="spinner" *ngIf="loading" >
  <mat-spinner></mat-spinner>

</div>
